import React from "react";
export const NumberedCardDemo = ({ index, title, content }) => (React.createElement("div", { className: "dark-numbered-card dark-numbered-card--demo" },
    React.createElement("h3", { className: "dark-numbered-card__title" },
        title,
        React.createElement("span", { className: "dark-numbered-card__index" }, index)),
    React.createElement("p", { className: "dark-numbered-card__content" }, content)));
